import { render } from "./CustomBadge.vue?vue&type=template&id=bf12637e&scoped=true"
import script from "./CustomBadge.vue?vue&type=script&lang=js"
export * from "./CustomBadge.vue?vue&type=script&lang=js"

import "./CustomBadge.vue?vue&type=style&index=0&id=bf12637e&scoped=true&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf12637e"]])

export default __exports__